module.exports = __webpack_public_path__ + "img/double-bank-statement.4800156d.svg";